import React, { useState, useEffect } from 'react';
import { Button } from 'appkit-react';
import { Skeleton } from 'antd';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Alert } from '@components';
import { API } from '@service';
import actions from '@flux/action';

import { QUES_SECTIONS_SEQ } from '@model/questionmaires';
import { filterXSS } from 'xss';

const FIRST_SECTION = QUES_SECTIONS_SEQ[0];

const WelcomePage = ({ canSeeComplex, canSeeQues }) => {
  const history = useHistory();
  const { path } = useRouteMatch();
  const location = useLocation();
  const { attribute, isLoading, abled, projectId } = useSelector(
    ({ question, common: { currentId } }) => ({
      attribute: question.attributes || {},
      isLoading: question.isFetchLoading,
      abled: question.complexitySiderData?.abled,
      question,
      projectId: currentId,
    }),
  );
  const isBack = Boolean(attribute.lastEditedAt);
  const [showPage, setShowPage] = useState(abled);

  const dispatch = useDispatch();

  useEffect(() => {
    setShowPage(abled);
  }, [abled]);
  if (showPage === false && canSeeComplex && !canSeeQues) {
    return (
      <div className="welcome-wrapper">
        <p className="title">Welcome,</p>
        <Skeleton loading={isLoading} active paragraph={{ rows: 7 }}>
          <div className="content">
            <p>
              The questionnaire is not completed yet, the deal complexity will
              be provided when the questionnaire is completed.
            </p>
          </div>
        </Skeleton>
      </div>
    );
  }
  if (showPage === undefined && canSeeComplex && !canSeeQues) {
    return (
      <div className="welcome-wrapper">
        <Skeleton loading={true} active paragraph={{ rows: 7 }} />
      </div>
    );
  }

  if (showPage === true && canSeeComplex && !canSeeQues) {
    setTimeout(() => {
      history.replace(
        filterXSS(`/questionnaires/complexity${location.search}`),
      );
    }, 600);
    return (
      <div className="welcome-wrapper">
        <Skeleton loading={true} active paragraph={{ rows: 7 }} />
      </div>
    );
  }

  const onConfirmReset = async () => {
    dispatch(actions.changeLoading(true));
    await API.resetQuestionnaire(projectId);
    dispatch(actions.changeLoading(false));
    dispatch(actions.fetchQuesCollections());
  };

  return (
    <div className="welcome-wrapper">
      <Skeleton loading={isLoading} active paragraph={{ rows: 7 }}>
        <p className="title">{isBack ? 'Welcome Back' : 'Welcome'},</p>
        <div className="content">
          <p>
            The Diagnostic Questionnaire is the first step of an integration
            process, which creates a holistic overview of expected complexity
            ahead of the integration.
          </p>
          <p>
            The completed questionnaire will provide an initial assessment of
            levels of complexity across five major sections: Strategy, Value,
            Enterprise, People, Execution. This will help drive an understanding
            of levels of effort and resources needed to successfully execute the
            integration.
          </p>
        </div>
        {isBack ? (
          <Button
            kind="secondary"
            size="lg"
            style={{ minWidth: '15.375rem' }}
            className="reset-qs-button"
            onClick={() =>
              Alert.confirm({
                className: 'reset-qs-modal alert-warning-save',
                okText: 'Yes',
                cancelText: 'No',
                content:
                  'By resetting the responses, you will be resetting the full Questionnaire. Are you sure you want to proceed?',
                onOk: onConfirmReset,
                confirmLoading: true,
              })
            }
          >
            Reset All Response
          </Button>
        ) : null}
        <Button
          kind="primary"
          size="lg"
          style={{ minWidth: '15.375rem' }}
          className="create-btn"
          onClick={() => history.replace(`${path}/${FIRST_SECTION}`)}
        >
          {isBack ? 'Continue' : 'Start'} Questionnaire
        </Button>
      </Skeleton>
    </div>
  );
};

export default WelcomePage;
